export type DealerVersionSource = {
  version?: number | string | null;
} | null | undefined;

export const isV2Dealership = (dealer: DealerVersionSource): boolean =>
  Number(dealer?.version) === 2;
